/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ShutDownTimeType {
  None = 'None',
  ByLastItem = 'ByLastItem',
  ByNow = 'ByNow'
}
